import {
	addPeriod,
	getCapitalCase,
	getCapitalCaseAll,
	getNumberOfNightsBetweenDates,
} from '../../utils';
import React, { useCallback, useEffect } from 'react';
import {
	selectSession,
	updateReservation,
} from '../../redux/slices/sessionSlice';
import { useAppDispatch, useAppSelector } from './../../redux/hook';

import { completeStage } from '../../redux/slices/stageSlice';
import { DarkButton } from '../../components/dark-button';
import { DarkInfoCard } from '../../components/dark-info-card';
import format from 'date-fns/format';
import { selectStage } from '../../redux/slices/stageSlice';
import { useTranslation } from 'react-i18next';

export default function ReservationProfileFormHome() {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const { token, reservation, propertyInfo, settings } =
		useAppSelector(selectSession);
	const { stages, stage } = useAppSelector(selectStage);
	const enableDocSubmission = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableDocSubmission' &&
			setting.parameterValue === 'false'
	);

	const updateReservationProfile = (vars: any) => {
		const params = {
			token: token,
			reservationID: reservation?.ReservationID,
			profileID: reservation?.ProfileID,
			pmsConfirmationNo: reservation?.PmsConfirmationNo,
			title: vars?.Title,
			firstName: vars?.FirstName,
			middleName: vars?.MiddleName,
			lastName: vars?.LastName,
			email: vars?.EmailID,
			phoneNo_Res: vars?.PhoneNo,
		};
		dispatch(updateReservation(params));
	};

	const completeInitialStage = () => {
		dispatch(
			completeStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
				propertyCode: propertyInfo?.propertyCode ?? '',
			})
		);
	};

	const htmlDecode: (input: string) => string | TrustedHTML = (
		input: string
	) => {
		const e = document.createElement('p');
		e.innerHTML = input;
		const html = e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
		console.log('html', html);
		console.log('input', input);
		console.log('e', e);
		return input;
	};

	return (
		<>
			<div
				className="d-flex flex-column gap-4 vh-100 mx-auto justify-content-between"
				style={{ paddingBottom: '110px', overflow: 'auto' }}>
				<div className="d-flex flex-column gap-4">
					<div
						className="d-flex flex-column gap-2 align-items-center justify-content-center py-2 text-white m-0 theme-welcome-header"
						style={{
							minHeight: '80px',
							background: '#03355C',
							textAlign: 'center',
						}}>
						<div className="d-flex flex-column align-items-center">
							<p className="fs-2 m-0">{t('LandingPageHeader')}</p>
						</div>
					</div>
					<div className="px-3 d-flex flex-column gap-4 mt-2">
						<div className="d-flex flex-column text-lg-center">
							<h2
								className="mb-0 theme-guest-name"
								style={{
									fontSize: '1.5rem',
								}}>
								{/* {propertyInfo?.propertyCode == 'YAM' ||
								process.env.REACT_APP_THEME == 'YAM' */}
								{getCapitalCase(
									addPeriod(reservation?.Title ?? '') +
										' ' +
										(reservation?.FirstName ?? '') +
										' ' +
										(reservation?.LastName ?? '')
								)}
								{/* : getCapitalCase(
											reservation?.FirstName || reservation?.LastName
												? reservation?.FirstName +
														' ' +
														reservation?.LastName +
														','
												: 'Guest User'
									  )} */}
							</h2>
							<p className="mb-0 lh-sm mt-2 theme-welcome-intro">
								{t('LandingPageWelcomeMessage')}
							</p>
						</div>

						<DarkInfoCard
							confirmationNumber={reservation?.PmsConfirmationNo}
							cardFields={[
								{
									title: t('LandingPagePropertyName'),
									description: propertyInfo?.property ?? '',
									textStyle: 'true',
									span: 12,
								},
								{
									title: t('LandingPageArrivalDate'),
									description: getCapitalCaseAll(
										format(new Date(reservation?.ArrivalDate), 'dd/MMM/yyyy')
									)!,
									textStyle: 'true',
									span: 6,
								},
								{
									title: t('LandingPageDepartureDate'),
									description: getCapitalCaseAll(
										format(new Date(reservation?.DepartureDate), 'dd/MMM/yyyy')
									)!,
									textStyle: 'true',
									span: 6,
								},
								{
									title:
										t('LandingPageAdult').trim() +
										t('LandingPageChildren').trim(),
									description:
										reservation?.AdultCount +
										'' +
										(t('LandingPageChildren').trim() === ''
											? ''
											: '/' + (reservation?.ChildCount ?? 0)),
									textStyle: 'true',
									span: 6,
								},
								{
									title: t('LandingPageNumberOfNights'),
									description: getNumberOfNightsBetweenDates(
										new Date(reservation?.ArrivalDate),
										new Date(reservation?.DepartureDate)
									)!,
									textStyle: 'true',
									span: 6,
								},
								{
									title: t('LandingPageRoomType'),
									description: getCapitalCase(
										reservation?.RoomTypeName ?? reservation?.RateCode
									)!,
									textStyle: 'true',
									span: 6,
								},
							]}
						/>
					</div>
				</div>

				{/* <ReservationProfileForm
						key={'form'}
						reservation={reservation}
						submit={updateReservationProfile}
					/> */}
				{enableDocSubmission === null ||
					(enableDocSubmission === undefined && (
						<>
							<div className="px-5 text-center text-black-50 pb-3 justify-self-end">
								{t('LandingPageFooterMessage')}
							</div>
						</>
					))}
			</div>
			<div
				className="fixed-bottom w-100 px-5 pb-4 pt-1 border-top d-flex flex-row justify-content-center theme-footer"
				style={{ backgroundColor: 'white', borderColor: 'gray' }}>
				{reservation?.PmsConfirmationNo && (
					<DarkButton
						text={t('LandingPageButton')}
						onClick={completeInitialStage}
						filled
					/>
				)}
			</div>
		</>
	);
}
